import { Star } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/motion";
import { DOCTOR } from "@/config/doctorConfig";

export const Reviews = () => (
  <section id="reviews" className="bg-white border-y border-slate-200/70 py-16 sm:py-24" data-testid="reviews-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="flex justify-center">
        <SectionHeading
          number="11"
          eyebrow="Patient Feedback"
          title="What Patients Say"
        />
      </div>
      <Reveal delay={2}>
        <div className="mt-10 rounded-3xl border border-dashed border-slate-300 bg-slate-50/70 px-8 py-14" data-testid="reviews-placeholder">
          <div className="flex justify-center gap-1.5 mb-5" aria-hidden="true">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={20} className="text-slate-300" />
            ))}
          </div>
          <p className="font-serif text-xl text-slate-500 italic">
            "Patient reviews will be displayed here."
          </p>
          <p className="mt-3 text-sm text-slate-500 max-w-md mx-auto leading-relaxed">
            Genuine patient feedback will be published in this space. We do not display
            unverified or fabricated testimonials.
          </p>
          <a
            href={DOCTOR.googleProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-google-profile-btn"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold text-white bg-navy-900 hover:bg-navy-700 transition-colors duration-200"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            View Google Profile &amp; Reviews
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
